import { FaPlay } from "react-icons/fa";
import styles from "./video.module.scss";

interface Props {
  show?: boolean;
  top?: number;
  right?: number;
  radius?: string;
}

const VideoTag = ({ show, ...p }: Props) => {
  if (!show) return null;
  return (
    <div
      className={styles.playIcon}
      style={{
        top: p.top ?? -7,
        right: p.right ?? -7,
        borderRadius: p.radius ?? `50%`,
      }}
    >
      <FaPlay size={8} />
    </div>
  );
};

export default VideoTag;
